import {useRef, useState} from "react";
import {BiSearch, BiMapPin} from "react-icons/bi";
import {POSITIONS} from "@/configuration/static-data-provider";

import MassesTimeSearch from "@/components/shared/masses-time";
import ClergiesBlock from "./clergies-block";
import {ScrollShadow} from "@nextui-org/react";
import {getPriest} from "@/services/home-service";

export default function ClergySearch({
                                         title = "GIÁO PHẬN PHÚ CƯỜNG",
                                         tabs = [
                                             {id: "spiritual", label: "Thông Tin Linh Mục"},
                                             {id: "diocese", label: "Giờ Lễ - Giáo Hạt - Giáo Xứ"},
                                         ],
                                         deaneries,
                                         className = "",
                                     }) {
    const [activeTab, setActiveTab] = useState(tabs[0].id);
    const [clergies, setClergies] = useState([]);
    const [churches, setChurches] = useState([]);
    const [searchData, setSearchData] = useState({
        // search linh mục
        clergyName: "",
        deaneryId: "",
        pageSize: 10,

        // search giờ lễ
        appointmentID: "35457ea2-8fcd-43b9-9535-22ef79f771da",
        churchName: "",
        timeMass: "",
    });
    const deaneriesData = deaneries.value;
    const nullDeanery = {
        id: "",
        name: "Chọn Giáo Hạt",
        value: "",
    };
    const combinedDeaneries = [nullDeanery, ...deaneriesData];

    const handleSearch = async () => {
        if (activeTab === "diocese") {
            const {clergyName, deaneryId, pageSize, ...rest} =
                searchData;
            await fetch("api/churchs", {
                method: "POST",
                body: JSON.stringify(rest),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => setChurches(data));
        } else {
            const {appointmentID, churchName, timeMass, ...rest} = searchData;
            const response = await getPriest(rest);
            setClergies(response);
        }
    };

    const handleInputChange = (field, value) => {
        setSearchData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <div className={`w-full ${className}`}>
            {/* Title */}
            <h1 className="text-3xl font-bold text-primary text-center mb-6">
                {title}
            </h1>

            {/* Tabs */}
            {/* TODO:  */}
            <div className="flex justify-center gap-3 mb-6">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`px-6 py-3 rounded-full font-medium transition-all ${
                            activeTab === tab.id
                                ? "bg-primary text-white shadow-md"
                                : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Search Form */}
            {/* TODO:  */}
            {activeTab === "spiritual" ? (
                <div className="bg-gray-200 rounded-2xl p-6 shadow-lg">
                    <div className="flex flex-col md:flex-row gap-3 mb-4">
                        {/* Name/Title Input */}
                        <div className="flex-[2] relative">
                            <BiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"/>
                            <input
                                type="text"
                                placeholder="Nhập tên linh mục"
                                value={searchData.clergyName}
                                onChange={(e) =>
                                    handleInputChange(
                                        "clergyName",
                                        e.target.value
                                    )
                                }
                                className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        {/* Parish Dropdown */}
                        <div className="flex-1 relative">
                            <BiMapPin className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"/>
                            <select
                                value={searchData.deaneryId}
                                onChange={(e) =>
                                    handleInputChange("deaneryId", e.target.value)
                                }
                                className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white cursor-pointer"
                            >
                                {combinedDeaneries.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* Search Button */}
                        <button
                            onClick={handleSearch}
                            className="px-8 py-3.5 bg-cyan-500 hover:bg-cyan-600 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2 shadow-md"
                        >
                            <BiSearch className="text-xl"/>
                            <span>Tìm kiếm</span>
                        </button>
                    </div>
                    {clergies?.value && (
                        <ScrollShadow
                            hideScrollBar
                            orientation="horizontal"
                            className="w-full h-[600px]"
                        >
                            <ClergiesBlock
                                clergies={clergies}
                                isPagination={false}
                            />
                        </ScrollShadow>
                    )}
                </div>
            ) : (
                <MassesTimeSearch
                    deaneries={deaneriesData}
                    searchData={searchData}
                    churches={churches}
                    handleSearch={handleSearch}
                    handleInputChange={handleInputChange}
                />
            )}
        </div>
    );
}
